export default function FoldersSidebar() {
    return (
        <aside className="w-[260px] bg-[#262628] flex flex-col border-r border-black/40 flex-shrink-0 hidden md:flex">
            <div className="h-12 flex items-center justify-between px-4 mt-2">
                <div className="flex items-center gap-2 text-[#EBEBF5] opacity-50 transition-opacity">
                    <i className="ph ph-caret-left text-xl"></i>
                    <span className="text-[15px] font-medium">Folders</span>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-2 py-2 space-y-0.5">
                <div className="mt-1 space-y-0.5">
                    <div className="px-3 py-2 flex items-center gap-3 rounded-[6px] bg-[#C69C08]/20 group">
                        <i className="ph ph-folder-open text-[#FFB400] text-xl"></i>
                        <span className="text-[14px] font-medium flex-1 text-[#FFB400]">dilli.wiki</span>
                        <span className="text-[#8E8E93] text-sm text-[#FFB400]">9</span>
                    </div>
                </div>
            </div>
        </aside>
    );
}
